import dayjs from "dayjs"

class Booking {
  constructor(rawBooking) {
    this.startDateTime =
      rawBooking["slot-start-datetime"] &&
      dayjs(rawBooking["slot-start-datetime"])
    this.endDateTime =
      rawBooking["slot-end-datetime"] && dayjs(rawBooking["slot-end-datetime"])
    // Two distinct job numbers, deliberately not interchangeable:
    // mopJobNumber identifies the booking for cancel/update and is never shown
    // (it is a UUID for SMS bookings), displayJobNumber is the customer-facing
    // reference and is never sent. Do not fall back from one to the other.
    this.mopJobNumber = rawBooking["mop-job-number"]
    this.displayJobNumber = rawBooking["display-job-number"]
    this.address = rawBooking.address
    this.postcode = rawBooking.postcode
    this.customerName = rawBooking["customer-name"]
    this.customerEmail = rawBooking["customer-email"]
    this.customerPhone = rawBooking["customer-phone"]
    this.cancellationDateTime =
      rawBooking["cancellation-date-time"] &&
      dayjs(rawBooking["cancellation-date-time"])
    this.createdDate =
      rawBooking["created-at"] && dayjs(rawBooking["created-at"])
    this.aesStatus = rawBooking["aes-status"]
  }

  get isActive() {
    if (!this.startDateTime) return false
    const status = String(this.aesStatus ?? "").toUpperCase()
    if (!["BOOKED", "RESCHEDULED"].includes(status)) return false
    return !this.startDateTime.isBefore(dayjs().startOf("day"))
  }

  get fullAddress() {
    return [this.address, this.postcode].join(", ")
  }

  get appointmentDateFormatted() {
    if (!this.startDateTime) return null
    return this.startDateTime.format("D MMM YYYY")
  }

  get appointmentStartTime() {
    if (!this.startDateTime) return null
    return this.startDateTime.format("HH:mm")
  }

  get appointmentEndTime() {
    if (!this.endDateTime) return null
    return this.endDateTime.format("HH:mm")
  }

  get appointmentTimeSlot() {
    if (!this.appointmentStartTime || !this.appointmentEndTime) return null
    return `${this.appointmentStartTime} - ${this.appointmentEndTime}`
  }

  get cancellationDate() {
    if (!this.cancellationDateTime) return null
    return this.cancellationDateTime.format("HH:mm D MMM YYYY")
  }

  get isEligibleForCancellation() {
    return (
      this.startDateTime &&
      dayjs().isBefore(this.startDateTime.subtract(24, "hour"))
    )
  }
}

export default Booking
